import Fact from "./Fact"
export default Fact
